<template>
  <action-log-template :actionLog="actionLog">
    <template #actionName>
      <p :class="['action-type flex-row flex__left inline-flex']">
        <i
          :class="['font-size__small', 'fal fa-check-circle', 'color__blue']"
        ></i>
        <span class="font-size__small no_wrap color__blue">
          &nbsp;{{ actionNameLabel || "-" }}
        </span>
      </p>

      <span class="color__blue font-italic">
        thời hạn hoàn thành&nbsp;
        {{
          deadline
            | dateFormatter({
            nullValue: "-",
            dateFormat: "DD/MM/YYYY"
          })
        }}
      </span>
    </template>
  </action-log-template>
</template>

<script>
import convertToLabelFilter from "../../../filters/convertToLabelFilter";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import ActionLogTemplate from "./action-log-template";
import dateFormatter from "../../../filters/dateFormatter";

export default {
  name: "hc-commands-cho-y-kien-action-log",
  components: {ActionLogTemplate},
  props: ["actionLog"],
  filters: {
    convertToLabelFilter,
    dateFormatter
  },
  data() {
    return {
      actionNameLabel: null,
      dataJson: null,
      deadline: null
    };
  },
  created() {
    this.actionNameLabel = hanhChinhUtils.getActionLogActionNameLabel(
      this.actionLog.actionName
    );
    this.dataJson = JSON.parse(this.actionLog.dataJson);
    this.deadline = this.dataJson.deadline;
  },
  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-commands-cho-y-kien-action-log.vue